import React from 'react';

import {useDeferredData} from 'coreHooks/useDeferredData';
import {SEO_DATA_KEY} from 'coreHooks/useSeo';

import SEO from './SEO';

/**
 * Suspense-aware SEO wrapper for brands using `StrictLocaleLoaderRouter`.
 *
 * Suspends via `useDeferredData` until the page's queryFn resolves the
 * SEO deferred (via `usePageInit`, or
 * `PageInitSafetyNet`). By that time Redux already contains the correct
 * metadata, so the inner `<SEO />` renders with the right Helmet tags.
 *
 * Wrap this component in a `<Suspense fallback={null}>` boundary inside
 * the brand's `_app`.  Legacy brands that still use `LoaderRouter` should
 * keep using `<SEO />` directly.
 */
const SuspenseSEO = () => {
	useDeferredData(SEO_DATA_KEY);

	return <SEO />;
};

export default SuspenseSEO;
